<template>
  <slot />
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'

const props = defineProps<{
  id: number
  index: number
  modal?: boolean
  hideCloseButton?: boolean
}>()

provide('dialogId', props.id)
provide('dialogIndex', props.index)
provide('dialogModal', !!props.modal)
provide(
  'dialogHideCloseButton',
  computed(() => !!props.hideCloseButton)
)
</script>
